import { getLegalEntity } from '@cemex/cmx-client-layout';
import { createSelector } from '@ngrx/store';
import { selectActiveProductTypeEntity, selectProductTypeState } from './product-type.selector';
export const selectActiveLegalEntityAndActiveProductType = createSelector(
  getLegalEntity,
  selectActiveProductTypeEntity,
  (activeLegalEntity, activeProductType) => ({
    activeLegalEntity,
    activeProductType,
  }),
);

export const selectActiveLegalEntityAndProductTypeState = createSelector(
  getLegalEntity,
  selectProductTypeState,
  (activeLegalEntity, productTypeState) => ({
    activeLegalEntity,
    productTypeState,
  }),
);
